import { render, staticRenderFns } from "./shoppingGuideTask_editor.vue?vue&type=template&id=3ebf04ca&scoped=true"
import script from "./shoppingGuideTask_editor.vue?vue&type=script&lang=js"
export * from "./shoppingGuideTask_editor.vue?vue&type=script&lang=js"
import style0 from "./shoppingGuideTask_editor.vue?vue&type=style&index=0&id=3ebf04ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebf04ca",
  null
  
)

export default component.exports